import styled from '@emotion/styled'
import { useContext, useEffect, useState } from 'react'
import { Flex } from 'rebass'
import { useMediaQuery } from 'react-responsive'

import CONST from '../../../utils/const'
import { getRandomValue } from '../../../utils/utility'
import ComputerChoseMobile from './ComputerChoseMobile'
import ComputerChoseDesktop from './ComputerChoseDesktop'
import { GameDifficultyContext } from '../../../utils/GameModeContext'

const ComputerChoseContainer = styled(Flex)`
  width: 600px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 1366px) {
    height: 100%;
  }
`

const ComputerChose = ({ userChose, onComputerChosen }) => {
  const { difficulty } = useContext(GameDifficultyContext)

  const isSmallScreen = useMediaQuery({
    query: '(max-width: 1366px)'
  })
  const [computerChose, setComputerChose] = useState('')

  useEffect(() => {
    let randomValue = ''
    setTimeout(() => {
      randomValue = getRandomValue(Object.keys(CONST.WHO_BEATS_WHO[difficulty]))
      setComputerChose(randomValue)
      setTimeout(() => {
        onComputerChosen(randomValue)
      }, 1500)
    }, 500)
  }, [difficulty, onComputerChosen])

  return (
    <ComputerChoseContainer>
      {isSmallScreen ? (
        <ComputerChoseMobile userChose={userChose} computerChose={computerChose} />
      ) : (
        <ComputerChoseDesktop userChose={userChose} computerChose={computerChose} />
      )}
    </ComputerChoseContainer>
  )
}

export default ComputerChose
